<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">School Teacher's Information</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <div class="container mt-4">
                    <div class="row g-4 justify-content-center">
                        <div class="col-lg-4 col-md-6" *ngFor="let item of paginated_teachers_info">
                            <!-- Ultimate 3D Profile Card -->
                            <div class="ultimate-3d-profile-card d-flex flex-column" style="cursor: pointer;" data-bs-toggle="modal" [attr.data-bs-target]="'#quote' + item.EmployeeId">
                                <div class="profile-image-container">
                                    <img [src]="item.ImageLink || 'assets/img/default-teacher.png'" alt="teacher" />
                                </div>
                                <div class="profile-content flex-grow-1 d-flex flex-column">
                                    <h3 class="profile-name">{{ item.EmployeeName }}</h3>
                                    <p class="profile-role mb-2">{{item.Designation }}</p>
                                    <p class="text-muted" style="font-size: 13px; font-weight: 500;">Dept: {{ item.Department}}</p>
                                    
                                    <div class="mt-auto">
                                        <button class="premium-glass-btn btn-sm py-2 px-4" style="font-size: 13px;">
                                            View Profile
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Modal -->
                            <div class="modal fade" [id]="'quote' + item.EmployeeId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="ultimate-3d-card modal-content" style="border: none;">
                                        <div class="modal-header border-0 pb-0" style="background: transparent;">
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body p-5 text-center" style="color: #334155;">
                                            <div class="mb-4">
                                                <img [src]="item.ImageLink || 'assets/img/default-teacher.png'" style="width: 150px; height: 150px; border-radius: 50%; object-fit: cover; border: 4px solid #0d8b54; box-shadow: 0 10px 25px rgba(13, 139, 84, 0.2);">
                                            </div>
                                            <h3 class="fw-bold mb-1" style="color: #0f4c3a;">{{ item.EmployeeName }}</h3>
                                            <p class="text-success fw-bold mb-4">{{ item.Designation }}</p>
                                            
                                            <div class="row text-start mt-4">
                                                <div class="col-6 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">ID</small>
                                                    <div class="fw-semibold">{{ item.EmployeeId }}</div>
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Department</small>
                                                    <div class="fw-semibold">{{ item.Department || '--' }}</div>
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Blood Group</small>
                                                    <div class="fw-semibold">{{ item.BloodGroup || '--' }}</div>
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Joining Date</small>
                                                    <div class="fw-semibold">{{ item.JoiningDate | date: 'dd-MM-yyyy' }}</div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Mobile</small>
                                                    <div class="fw-semibold">{{ item.MobileNo }}</div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <small class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Email</small>
                                                    <div class="fw-semibold">{{ item.EmailAddress || '--' }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Modal Ends -->
                        </div>
                    </div>

                    <!-- No Data Found Message -->
                    <div *ngIf="paginated_teachers_info.length === 0">
                        <div class="text-center py-5">
                            <div class="ultimate-3d-card p-5 mx-auto" style="max-width: 400px;">
                                <i class="fa-solid fa-users-slash" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                                <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Data Found</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-5 mb-5" *ngIf="totalPages.length > 1">
                    <button class="premium-glass-btn mx-1" (click)="onPageChange(pageIndex - 1)" [disabled]="pageIndex === 0">Previous</button>
                    <button class="premium-glass-btn mx-1" *ngFor="let page of totalPages; let i = index" (click)="onPageChange(i)" [ngStyle]="{'background': pageIndex === i ? 'linear-gradient(135deg, #0d8b54, #0f4c3a)' : '', 'color': pageIndex === i ? '#ffffff' : ''}">{{ page }}</button>
                    <button class="premium-glass-btn mx-1" (click)="onPageChange(pageIndex + 1)" [disabled]="pageIndex + 1 >= totalPages.length">Next</button>
                </div>

            </div>
        </div>
    </div>
</section>
